import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LayoutDashboard, Building2, CreditCard, Sparkles, LogOut } from "lucide-react";
import { Toaster } from "../../components/ui/sonner";

const NAV = [
  { to: "/admin", label: "Übersicht", icon: LayoutDashboard, end: true },
  { to: "/admin/unternehmen", label: "Unternehmen", icon: Building2 },
  { to: "/admin/tarife", label: "Tarife", icon: CreditCard },
  { to: "/admin/ki-nutzung", label: "KI-Nutzung", icon: Sparkles },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFAFA] text-zinc-900" data-testid="admin-layout">
      <header className="border-b border-zinc-200 px-6 py-4 flex items-center justify-between sticky top-0 bg-white/80 backdrop-blur z-30">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 bg-zinc-900 rounded-md flex items-center justify-center"><span className="text-white text-[10px] font-bold font-mono">L19</span></div>
            <span className="font-display font-semibold">L<span className="text-zinc-500">19</span> <span className="text-zinc-400 font-normal text-sm">Super-Admin</span></span>
          </div>
          <nav className="flex gap-1">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase()}`}
                className={({ isActive }) => `flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-colors ${isActive ? "bg-zinc-900 text-white" : "text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100"}`}>
                <n.icon className="w-4 h-4" /> {n.label}
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-xs font-mono text-zinc-500">{user?.email}</span>
          <button onClick={async () => { await logout(); navigate("/"); }} data-testid="admin-logout" className="text-zinc-400 hover:text-zinc-900"><LogOut className="w-4 h-4" /></button>
        </div>
      </header>
      <main className="max-w-7xl mx-auto p-6 lg:p-8">
        <Outlet />
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
}
